import React, { useState } from 'react';
import t from 'prop-types';

function Temas(_ref) {
  var modoCombo = _ref.modoCombo,
      titulo = _ref.titulo,
      placeHolder = _ref.placeHolder,
      temas = _ref.temas,
      datos = _ref.datos,
      onDatos = _ref.onDatos; // !modoCombo --------------------------------------------------------------

  var _useState = useState(false),
      desplegado = _useState[0],
      setDesplegado = _useState[1];

  var _useState2 = useState(placeHolder),
      numTemaSeleccionado = _useState2[0],
      setTema = _useState2[1];

  function handleDesplegar() {
    setDesplegado(!desplegado);
  }

  var temaInicio = placeHolder;
  temas.forEach(function (tema) {
    if (datos.join(",") === tema.datos) {
      temaInicio = tema.nombre;
    }

    return temaInicio;
  });
  window.setTimeout(function () {
    return setTema(temaInicio);
  }, 10); // -------------------------------------------------------------------------

  if (modoCombo) {
    return React.createElement('label', {
      className: 'opcionesDesplegable',
      htmlFor: 'opcionesDesplegable'
    }, titulo, React.createElement('select', {
      id: 'opcionesDesplegable',
      value: datos.join(","),
      onChange: function onChange(event) {
        return onDatos(event.target.value.split(","));
      }
    }, React.createElement('option', {
      value: ''
    }, placeHolder), temas.map(function (tema, index) {
      return React.createElement('option', {
        key: 'tema-' + index,
        value: tema.datos
      }, tema.nombre);
    })));
  } else {
    return React.createElement('div', {
      className: 'opcionesCombo'
    }, React.createElement('div', {
      className: 'combo ' + (desplegado ? 'abierta' : 'cerrada')
    }, React.createElement('div', {
      onClick: handleDesplegar,
      className: 'seleccionCombo'
    }, numTemaSeleccionado), React.createElement('div', {
      className: 'listaCombo'
    }, desplegado && React.createElement('div', {
      className: 'opcionCombo' + (placeHolder === numTemaSeleccionado ? ' activa' : ''),
      onClick: function onClick() {
        setTema(placeHolder);
        handleDesplegar();
        onDatos([]);
      }
    }, ' ', placeHolder, ' '), desplegado && temas.map(function (tema, index) {
      return React.createElement('div', {
        key: 'tema-' + index,
        className: 'opcionCombo' + (tema.nombre === numTemaSeleccionado ? ' activa' : ''),
        onClick: function onClick() {
          setTema(tema.nombre);
          handleDesplegar();
          onDatos(tema.datos.split(","));
        }
      }, tema.nombre);
    }))));
  }
}

Temas.propTypes = process.env.NODE_ENV !== "production" ? {
  modoCombo: t.bool,
  titulo: t.string,
  placeHolder: t.string,
  temas: t.array,
  datos: t.array,
  onDatos: t.func
} : {};
export default Temas;